import restAction from "../common/restAction";

const state = {
    cooperationManageNumber:0
};
const mutations = {
    setCooperationManageNumber(state, payload){
        state.cooperationManageNumber = payload;
    }
};
const actions = {
    setCooperationManageNumber(context,payload){
        const param = {
            url :'/api/copaper/cooperation/getMyCooperationManageCount',
            method :'post',
            obj:{},
            req:{ 
            }
        };
        restAction.actions.ASYNC_COWORK_REST_ACTION({}, param)
			.then(function(res) {
				if(res.errorCode == null) {
					context.commit("setCooperationManageNumber", res.result);
				}
		})
		.catch(function(err) {
			console.log(err);
		});
    }
};
const getters = {
    getCooperationManageNumber(state) {
        return state.cooperationManageNumber;
    }
};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/category/category.js